export default __webpack_public_path__ + "static/media/mail.ab845553.svg";